<template>
  <div class="page-home desk-frame">
    <header-desktop />
    <menu-desktop />
    <DashboardHeader />
    <transition name="slide">
      <Menu v-if="MENU_ACTIVE" />
    </transition>

    <div class="calandr_main calendar_desktop relative table-page">
      <div class="table-page-title-wrap flex mb-2">
        <h1 class="title--40 tx--blue2" style="margin-bottom:0">
          {{ pageTitle }}
        </h1>

        <div class="flex table-actions-container">
          <a
            v-if="canShowResetButton"
            class="clear-filters flex"
            href="javascript:void(0)"
            @click="getEvents('calender', true)"
          >
            <img src="/assets/img/svg/trash.svg" alt="" />איפוס תוצאות
          </a>
          <a
            class="clear-filters flex"
            href="javascript:void(0)"
            @click="onDownloadToExcel"
          >
            <img src="/assets/img/svg/download.svg" alt="" />ייצוא לקובץ
          </a>
        </div>
      </div>
      <div class="tb-top-search flex m-block">
        <div>
          <div class="text--20 tx-blue mb-1">
            טווח תאריכים:
          </div>
          <!-- Date picker -->
          <DateRangePicker
            v-model="dateRanges"
            :locale-data="locale"
            :linked-calendars="false"
            opens="left"
            @update="updateDatesFromCalendar"
          />
        </div>

        <!-- Search input -->
        <div v-show="showSearchInput" class="tbpage-main-search">
          <div class="tbpage-main-search-title flex mb-1">
            <div class="text--20 tx-blue">
              חיפוש לפי:
            </div>
            <div class="filter-booking-tabs flex flex--start">
              <div class="form_check form_radio desk-no-marge">
                <label class="form_check_tx">
                  ת.ז
                  <input
                    type="radio"
                    name="search_events"
                    v-model="searchType"
                    value="by_passport"
                  /><span class="checkmark"></span>
                </label>
              </div>
              <div class="form_check form_radio desk-no-marge">
                <label class="form_check_tx">
                  טלפון נייד
                  <input
                    type="radio"
                    name="search_events"
                    v-model="searchType"
                    value="by_phone"
                  /><span class="checkmark"></span>
                </label>
              </div>
              <div class="form_check form_radio desk-no-marge">
                <label class="form_check_tx">
                  שם
                  <input
                    type="radio"
                    name="search_events"
                    v-model="searchType"
                    value="by_name"
                  /><span class="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
          <div class="head_search relative">
            <form @submit.prevent="onSearch" autocomplete="off">
              <input
                class="head_search_input"
                type="text"
                :placeholder="'חיפוש ' + searchPlaceholder()"
                @keypress="validateIsNumber($event)"
                v-model="searchQuery"
              />
              <input class="head_search_submit" type="submit" value="" />
            </form>
          </div>
        </div>
      </div>

      <!-- Tables -->
      <div id="hmcTables">
        <h2 class="title--32 title-show-res mb-1 ft--300" v-if="getResultsBy">
          <span class="ft--400 tx--blue2">מציג תוצאות לפי:</span>
          {{ getResultsBy }}
        </h2>
        <custom-table
          :data="events"
          :tableType="tableType"
          :isFilteringByInput="isFilteringByInput"
          :downloadToExcel="downloadToExcel"
          ref="tableRef"
        ></custom-table>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderDesktop from "@/components/Shared/HeaderDesktop.vue";
import MenuDesktop from "@/components/Shared/MenuDesktop.vue";
import DashboardHeader from "@/components/Shared/Header";
import Menu from "@/components/Shared/Menu";
import CustomTable from "@/components/Table/CustomTable";
// import SearchInput from "@/components/Table/SearchInput";
import DateRangePicker from "vue2-daterange-picker";
import Error from "@/components/Popups/Error";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { mapGetters, mapActions, mapState } from "vuex";
import { LOCALE } from "../utilities/tables-config";
import { IVF_TREATMENT_LIST_ENABLED } from "../utilities/feature-flags";
import { filterEventsByPersonalLicense } from "../utilities/build-type-event.js";

export default {
  name: "SurgAppTable",
  components: {
    CustomTable,
    HeaderDesktop,
    MenuDesktop,
    Menu,
    DashboardHeader,
    DateRangePicker
    // SearchInput
  },
  data() {
    return {
      /**
       * @type {'appointment' | 'surgery' | 'pathology' | 'genetics' | 'ivf'}
       */
      tableTypes: ["appointment", "surgery", "pathology", "genetics", "ivf"],
      docsTableTypes: ["pathology", "genetics"], // For documents
      tableType: "appointment",
      tableRef: null,
      events: [],
      isFilteringByInput: false,
      /**
       * Reactive and controlled by
       * the user
       */
      searchType: "by_passport",
      searchQuery: "",
      /**
       * User cannot control those
       * static values. Meant only to
       * be displayed.
       */
      staticSearchType: "by_passport",
      staticSearchQuery: "",
      /**
       * Default values for datepicker.
       * Contains hebrew names and operators
       */
      locale: LOCALE,
      /**
       * Used in v-model inside datepicker.
       * Contains the range between the dates.
       * !IMPORTANT! date format "YYYY-MM-DDT00:00:00"
       */
      dateRanges: null,
      downloadToExcel: false
    };
  },
  created() {
    this.initializeTable();
    setTimeout(() => window.scrollTo({ top: 0 }), 100);
  },
  beforeDestroy() {
    this.CANCEL_PENDING_POLL();
  },
  computed: {
    ...mapGetters([
      "activeDoctor",
      "activeUser",
      "MENU_ACTIVE",
      "eventsByType"
    ]),
    /**
     * @returns {string}
     */
    pageTitle() {
      if (this.tableType == "appointment") return "רשימת תורים";
      else if (this.tableType == "surgery") return "רשימת ניתוחים";
      else if (this.tableType == "pathology") return "דוחות פתולוגיה";
      else if (this.tableType == "genetics") return "דוחות מעבדה גנטית";
      else if (this.tableType == "ivf") return "תוכניות טיפול IVF";
      else return "";
    },
    /**
     * @returns {boolean}
     */
    showSearchInput() {
      return !this.docsTableTypes.includes(this.tableType);
    },
    /**
     * @readonly the default state
     * of date ranges, according to the
     * client.
     */
    defaultRanges() {
      if (this.docsTableTypes.includes(this.tableType)) {
        return {
          startDate: this.$moment(new Date())
            .subtract(3, "week")
            .format("YYYY-MM-DDT00:00:00"),
          endDate: this.$moment().format("YYYY-MM-DDT00:00:00")
        };
      }
      return {
        startDate: this.$moment(new Date())
          .subtract(1, "M")
          .format("YYYY-MM-DDT00:00:00"),
        endDate: this.$moment(new Date())
          .add(1, "M")
          .format("YYYY-MM-DDT00:00:00")
      };
    },
    /**
     * Showing the user at any time what
     * events at shown to him and by what
     * if filters on.
     *
     * @returns {String} text to display
     */
    getResultsBy() {
      if (!this.isFilteringByInput) {
        return `תאריכים ${this.formatDate(
          this.dateRanges.startDate
        )} > ${this.formatDate(this.dateRanges.endDate)}`;
      } else if (this.staticSearchQuery) {
        return `${this.searchPlaceholder(true)} ${this.staticSearchQuery}`;
      }
      return "";
    },
    /**
     * Determine if the reset button will
     * be shown to the user. As long it's
     * not on the default dates this button
     * will be displayed.
     *
     * @returns {Boolean}
     */
    canShowResetButton() {
      if (this.isFilteringByInput) return true;
      return (
        JSON.stringify(this.defaultRanges) != JSON.stringify(this.dateRanges)
      );
    }
  },
  methods: {
    ...mapActions([
      "GET_DOCS_LIST",
      "POLL_PENDING_SUMMARIES",
      "CANCEL_PENDING_POLL"
    ]),
    /**
     * Initial function, runs whenever the component
     * is created and every time the route params
     * changes.
     */
    initializeTable() {
      this.events = [];
      if (!this.tableTypes.includes(this.$route.params.type)) {
        this.$router.replace("/table/appointment");
        return;
      }
      if (this.$route.params.type === "ivf" && !IVF_TREATMENT_LIST_ENABLED) {
        this.$router.replace("/table/appointment");
        return;
      }
      this.tableType = this.$route.params.type;
      this.dateRanges = { ...this.defaultRanges };

      /// User changed from appointment to
      /// surgery and opposite.
      const storageFilters = localStorage.getItem("search-values")
        ? JSON.parse(localStorage.getItem("search-values"))
        : null;
      const sessionFilterBy = sessionStorage.getItem("filter-by");
      if (
        (storageFilters && storageFilters.tableType !== this.tableType) ||
        !sessionFilterBy
      ) {
        this.getEvents();
        return;
      }

      /// Coming back from a page or
      /// opening the tables view again
      /// with session saved.
      let apiType = "calender";
      const parsedSession = JSON.parse(sessionFilterBy);
      if (parsedSession.dates) {
        this.dateRanges = parsedSession.dates;
        this.isFilteringByInput = false;
      } else {
        this.staticSearchType = parsedSession.searchType;
        this.staticSearchQuery = parsedSession.searchQuery;
        this.isFilteringByInput = true;
        apiType = "search";
      }
      this.getEvents(apiType);
    },
    /**
     * Get Events by api call type.
     *
     * @param {string} apiType
     * calender - getFullCalendarEvents
     * search - searchAppointments
     * else - getDocuments
     */
    getEvents(apiType = "calender", useDefaultDates = false) {
      if (useDefaultDates) this.dateRanges = { ...this.defaultRanges };

      this.isFilteringByInput = false;
      this.setToSessionStorage({ dates: this.dateRanges });

      if (this.tableType == "appointment" || this.tableType == "surgery") {
        if (apiType == "search") this.getSearchEvents(true);
        else this.getCalendarEvents();
      } else if (this.tableType == "ivf") {
        if (apiType == "search") this.getIVFList(true);
        else this.getIVFList();
      } else {
        this.getTableDocsEvents();
      }

      this.showMiniCalendars = false;
    },
    /**
     * Getting the values from datepicker
     * and setting dateRanges to them.
     *
     * @param {{ startDate: Date, endDate: Date }} values
     */
    updateDatesFromCalendar(values) {
      this.dateRanges = {
        startDate: this.$moment(values.startDate).format("YYYY-MM-DDT00:00:00"),
        endDate: this.$moment(values.endDate).format("YYYY-MM-DDT00:00:00")
      };
      this.searchQuery = "";

      if (this.$refs.tableRef) {
        this.$refs.tableRef.setPage(1);
      }
      this.getEvents();
    },
    /**
     * @param {Date} date
     */
    formatDate(date) {
      return this.$moment(date).format("DD-MM-YYYY");
    },
    /**
     * Returns hebrew display text to
     * show the user.
     *
     * @param {Boolean} showStatic use it
     * if you need to display the text in
     * getResultsBy computed
     *
     * @returns {String}
     */
    searchPlaceholder(showStatic = false) {
      const tmp = showStatic ? this.staticSearchType : this.searchType;
      if (tmp === "by_passport") return "ת.ז";
      if (tmp === "by_phone") return "טלפון נייד";
      if (tmp === "by_name") return "שם";

      return "";
    },
    /**
     * Checking if the user typed number or not.
     * Preventing the type of letter in case of
     * searching by phone.
     *
     * @param {Object} event comes from
     * whenever the user types.
     *
     * @returns {true | undefined}
     */
    validateIsNumber(event) {
      if (this.searchType === "by_name" || this.searchType === "by_passport") {
        return true;
      }
      event = event ?? window.event;
      const charCode = event.which ? event.which : event.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        event.preventDefault();
      } else {
        return true;
      }
    },
    /**
     * Get all the events from default or
     * selected dates, then Filtering them
     * by the type from tableType.
     */
    async getCalendarEvents() {
      /// API and filtering
      const filteredEvents = await this.$API.getFullCalendarEvents(
        this.activeUser.user_id,
        this.activeDoctor.id,
        this.tableType === "appointment"
          ? "appointment"
          : "surgery_gastro_ivf_catheterization",
        this.dateRanges.startDate,
        this.dateRanges.endDate
      );

      this.events = [];
      // in shared calendars keep only the events of the connected doctor
      this.events = filterEventsByPersonalLicense(filteredEvents).filter(e => {
        if (this.tableType === "appointment") {
          return e.appointment_id;
        } else {
          return e.surgery_id;
        }
      });
    },
    /**
     * Sending API request to filter events
     * from the search input.
     *
     * @param {Boolean} useStatic use it if
     * the session storage stores values to
     * search initially.
     */
    async getSearchEvents(useStatic = false) {
      if (this.searchQuery === "" && !useStatic) return;

      try {
        const response = await this.$API.searchAppointments(
          this.activeDoctor.id,
          useStatic ? this.staticSearchQuery : this.searchQuery,
          useStatic ? this.staticSearchType : this.searchType
        );

        this.setToSessionStorage({
          searchQuery: useStatic ? this.staticSearchQuery : this.searchQuery,
          searchType: useStatic ? this.staticSearchType : this.searchType
        });

        if (!useStatic) {
          if (this.$refs.tableRef) {
            this.$refs.tableRef.setPage(1);
          }
          this.staticSearchType = this.searchType;
          this.staticSearchQuery = this.searchQuery;
        }
        this.isFilteringByInput = true;
        this.searchQuery = "";

        if (!response || !response.data) {
          this.$modal.show(Error);
          return;
        }

        this.events = [];
        this.isFilteringByInput = true;
        this.events = response.data.filter(e =>
          e.event_id.includes(this.tableType)
        );
      } catch (error) {
        this.$modal.show(Error);
      }
    },
    /**
     * Handle search form submission
     * based on current table type.
     */
    onSearch() {
      if (this.tableType === "ivf") {
        this.getIVFList(false);
      } else {
        this.getSearchEvents(false);
      }
    },
    async getTableDocsEvents() {
      this.setToSessionStorage({ dates: this.dateRanges });
      await this.GET_DOCS_LIST({
        startDate: this.dateRanges.startDate,
        endDate: this.dateRanges.endDate
      });
      this.events = this.eventsByType[this.tableType] || [];
      /// Same range as the visible table, so a background refresh cannot
      /// swap the rows for a different date filter.
      this.POLL_PENDING_SUMMARIES(this.dateRanges);
    },
    /**
     * Get IVF events list with optional search or date filtering.
     *
     * @param {Boolean} useStatic use it if
     * the session storage stores values to
     * search initially.
     */
    async getIVFList(useStatic = false) {
      try {
        const query = useStatic ? this.staticSearchQuery : this.searchQuery;
        const queryType = useStatic ? this.staticSearchType : this.searchType;
        const fromDate = this.dateRanges?.startDate || null;
        const toDate = this.dateRanges?.endDate || null;

        const res = await this.$API.getIVFList(
          this.activeDoctor.id,
          query || null,
          query ? queryType : null,
          fromDate,
          toDate
        );

        if (!useStatic && this.searchQuery) {
          this.setToSessionStorage({
            searchQuery: this.searchQuery,
            searchType: this.searchType
          });

          if (this.$refs.tableRef) {
            this.$refs.tableRef.setPage(1);
          }
          this.staticSearchType = this.searchType;
          this.staticSearchQuery = this.searchQuery;
          this.isFilteringByInput = true;
          this.searchQuery = "";
        }

        this.events = res?.data || [];
      } catch (error) {
        this.$modal.show(Error);
      }
    },
    /**
     * @param {Object} value value to save to
     * session storage.
     *
     * ```ts
     * value = { search: 'by_name' }
     * ```
     */
    setToSessionStorage(value) {
      sessionStorage.setItem("filter-by", JSON.stringify(value));
    },
    onDownloadToExcel() {
      this.downloadToExcel = true;
      setTimeout(() => {
        this.downloadToExcel = false;
      }, 500);
    }
  },
  watch: {
    /**
     * Clearing the search every time
     * the user is changing th search type,
     * preventing user to write letters
     * in numbers only inputs.
     */
    searchType() {
      this.searchQuery = "";
    },

    activeDoctor() {
      this.getEvents();
    },

    $route(to, from) {
      if (!to.params.type || to.params.type === this.tableType) return;
      this.initializeTable();
    },

    /**
     * The pending-summary poll refreshes the store in the background, so
     * mirror those updates into the rendered rows of the documents tables.
     */
    eventsByType(byType) {
      if (!this.docsTableTypes.includes(this.tableType)) return;
      this.events = byType[this.tableType] || [];
    }
  }
};
</script>

<style>
.daterangepicker .calendars .ranges,
.daterangepicker .drp-selected {
  display: none;
}

.daterangepicker.show-calendar .drp-buttons {
  display: flex;
  /* flex-direction: row-reverse; */
  justify-content: flex-end;
}

.daterangepicker .calendars-container {
  flex-grow: 1;
  /* flex-direction: row-reverse; */
}

.daterangepicker .drp-calendar {
  max-width: initial;
  width: auto;
  flex: 1 1 auto;
}

.daterangepicker .calendar-table td,
.daterangepicker .calendar-table th {
  min-width: 50px;
  line-height: 40px;
  font-size: 20px;
}

.vue-daterange-picker {
  color: var(--blue);
}

.daterangepicker td.start-date {
  border-radius: 0 4px 4px 0;
}

.daterangepicker td.end-date {
  border-radius: 4px 0 0 4px;
}

.daterangepicker.ltr {
  direction: inherit;
  text-align: left;
}

.table-condensed .next,
.table-condensed .prev {
  transform: rotateY(180deg);
}
</style>
